import { useAppSelector } from "../redux/hooks";
import { login as loginService, logout as logoutService } from "../auth/authService";

/**
 * Convenience accessor for auth state + actions, replacing `useKeycloak()`.
 *  - `roles`  : effective role names from the access token (redux mirror)
 *  - `token`  : current access token (for the WS CONNECT header)
 *  - `subject`: user id (the former Keycloak `sub`)
 */
export function useAuth() {
  const roles = useAppSelector((state) => state.auth.roles);
  const token = useAppSelector((state) => state.auth.access_token);
  const subject = useAppSelector((state) => state.auth.subject);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isAuthInitialized = useAppSelector((state) => state.auth.isAuthInitialized);

  return {
    roles,
    token,
    subject,
    isAuthenticated,
    isAuthInitialized,
    login: loginService,
    logout: logoutService,
  };
}
